import MaterialItem from '@Features/MaterialRequest/requests/MaterialRequisition/form/components/MaterialsSection/components/MaterialListItems/components/MaterialItem';
import { useAppDispatch } from '@Hooks/index';
import { modalActions } from '@Store/slices/modalSlice';
import { MaterialRequisitionItemFormResponse } from '@Types/api/form';
import { useCallback } from 'react';

interface MaterialTabItemMobileProps {
  dataSource: MaterialRequisitionItemFormResponse[] | null;
}

const MaterialTabItemMobile: React.FC<MaterialTabItemMobileProps> = ({
  dataSource,
}) => {
  const dispatch = useAppDispatch();

  const handleDeleteItem = useCallback(
    (requisitionItemId: number) => {
      dispatch(
        modalActions.setStatusModal({
          key: String(requisitionItemId),
          status: true,
          type: 'Delete',
        })
      );
    },
    [dispatch]
  );

  const handleEditItem = (requisitionItemId: string | number): void => {
    dispatch(
      modalActions.setStatusModal({
        key: String(requisitionItemId),
        status: true,
        type: 'Edit',
      })
    );
  };

  if (!dataSource?.length) {
    return null;
  }

  return (
    <>
      {dataSource.map(
        ({
          reqItemId,
          actCode,
          actId,
          actName,
          matDesc,
          matCode,
          matId,
          plantCode,
          plantId,
          plantName,
          ledgerName,
          ledgerCode,
          ledgerId,
          reqQty,
          resDesc,
          resCode,
          unitId,
          transferRemarks,
          repeatForAll,
        }) => (
          <MaterialItem
            index={reqItemId}
            activityCode={actCode}
            activityId={actId}
            activityName={actName}
            materialDescription={matDesc}
            materialCode={matCode}
            materialId={matId}
            plantCode={plantCode}
            plantId={plantId}
            plantName={plantName}
            ledgerName={ledgerName}
            ledgerCode={ledgerCode}
            ledgerId={ledgerId}
            qty={reqQty}
            remarks={transferRemarks}
            resourceDescription={resDesc}
            resourceCode={resCode}
            unit={unitId}
            handleDeleteItem={() => handleDeleteItem(reqItemId)}
            handleEditItem={() => handleEditItem(reqItemId)}
            repeatItem={repeatForAll}
            key={reqItemId}
          />
        )
      )}
    </>
  );
};

export default MaterialTabItemMobile;
